import Box from '~/common/mui/Layout/Box';

type ModalContentProps = React.ComponentProps<typeof Box>;

const ModalContent = ({ children, ...props }: Readonly<ModalContentProps>) => {
  return (
    <Box className="mui-modal-content" {...props}>
      {children}
    </Box>
  );
};

export default ModalContent;
